/*
 * Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import PageContentContainer from "../../Container/PageContentContainer";
import { maintenancePageStyles } from "./maintenancePageStyle";
import backgroundTeaser from "../../../assets/img/generic/Teaser_Bird_404.jpg";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

const MaintenancePage = () => {
  return (
    <PageContentContainer size={"tiny"} backgroundColor={"white"}>
      <Box
        component={"img"}
        src={backgroundTeaser}
        alt={"Bird Teaser Maintenance"}
        sx={maintenancePageStyles.teaserImage}
      />
      <Typography variant={"h3"} sx={maintenancePageStyles.container}>
        Wartungsarbeiten
      </Typography>
      <Typography component="p" sx={maintenancePageStyles.container}>
        Wir verbessern gerade unseren Service für Sie. Sie erreichen uns morgen Vormittag wieder!
      </Typography>
      <Typography component="p" sx={maintenancePageStyles.container}>
        Beste Grüße
      </Typography>
      <Typography component="p" sx={maintenancePageStyles.container}>
        Ihr Legalbird-Team
      </Typography>
    </PageContentContainer>
  );
};

export default MaintenancePage;
